const styles = {
  colors: {
    action: '#f23c3c',
    deepBlack: '#000000',
    black: '#333333',
    brand: '#2fb3bf',
    cream: '#FFFBF8',
    gold: '#f2d33c',
    pink: '#FF98CFFF',
    facebook: '#4767AD',
    omnivore: '#2f77bf',
    omnivoreHover: '#265f99',
    vegan: '#3bbf2f',
    oliveGreen: '#8ea924',
    veganVariant: '#6EA133',
    darkGrey: '#767676',
    lessDarkGrey: '#909090',
    grey: '#aaaaaa',
    lightGrey: '#e6e6e6',
    veryLightGrey: '#f7fafa',
    orange: '#FF9162',
    peach: '#ffd1be',
    twitter: '#4da7de',
    pinterest: '#AF2626',
    white: '#ffffff',
    recipeTag: '#f9f77f',
    articleTag: '#FFC0DDFF',
    challenge: '#4d5e6d',
    ambassador: '#7500CB',
    tangerine: '#f9642d',
    blueberry: '#09163f',
    blueberryVariant2: '#1A2958',
    lessDarkBlueberry: '#46568c',
    skyblueBlueberry: '#f3f5ff',
    ocean: '#039BE5',
    coolBlue: '#29a0e3',
    transparent: '#ffffff00'
  },
  fonts: {
    baseSize: '16px',
    quarterSize: '20px',
    halfSize: '24px',
    doubleSize: '32px'
  },
  fontWeight: {
    mediumLight: 300,
    normal: 400,
    medium: 500,
    bold: 600,
    extraBold: 700
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    extraLarge: '24px'
  },
  height: {
    xtiny: '20px',
    tiny: '30px',
    small: '48px',
    medium: '72px',
    large: '98px'
  },
  margin: {
    tiny: '4px',
    small: '8px',
    medium: '16px',
    large: '32px',
    larger: '64px',
    extraLarge: '10%'
  },
  padding: {
    tiny: '4px',
    small: '8px',
    medium: '12px',
    large: '24px',
    larger: '48px',
    huge: '64px',
    media: '15vw'
  },
  width: {
    tiny: '30px',
    small: '48px',
    smallMedium: '76px',
    medium: '108px',
    mediumLarge: '180px',
    large: '216px',
    extraLarge: '450px'
  },
  breakpoints: {
    // min should normally be 1px greater than max
    minMobileSmall: '321px',
    maxMobileSmall: '320px',
    minMobileLarge: '376px',
    maxMobileLarge: '375px',
    minDesktop: '1001px',
    maxDesktop: '1000px'
  }
}

export default styles
